<template>
  <v-row>
    <v-col cols="12" sm="12" md="12">
      <a-text-field
        v-if="formData.isEdit"
        v-model.trim="formData.question"
        required
        :label="$t('poll.lblSurveyQuestion')"
        :requiredMessage="$t('agenda.ruleTopicNameReq')"
        :prefix="questionNumber"
      ></a-text-field>
      <span v-else>{{ questionNumber }}{{ formData.question }}</span>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <option-form v-model="formData.options"></option-form>
    </v-col>
    <v-col v-if="select === 'choice'" cols="12" sm="6" md="6">
      <v-switch
        dense
        hide-details
        :label="$t('poll.lblMultipleAnswer')"
        v-model="formData.isMultipleAnswer"
        class="mt-0 pt-0"
      ></v-switch>
    </v-col>
    <v-col cols="12" sm="6" md="6">
      <v-switch
        dense
        v-model="formData.isMandatory"
        hide-details
        :label="$t('poll.lblMandatoryResponse')"
        class="mt-0 pt-0"
      ></v-switch>
    </v-col>
  </v-row>
</template>

<script>
import OptionForm from "./OptionForm.vue";
import QuestionForm from "./QuestionForm.vue";
export default {
  components: { QuestionForm, OptionForm },
  name: "AddQuestion",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      select: "choice",
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    questionNumber() {
      return `${this.formData.number}. `;
    },
  },
  methods: {
    close,
    addQuestion,
  },
};

function addQuestion() {
  this.close();
}

function close() {
  // this.$refs.refAddQuestionSurveyForm.resetValidation();
  // this.$refs.refAddQuestionSurveyForm.reset();
  this.$emit("input", false);
}
</script>

<style>
</style>